import * as React from 'react';
import { ExternalPageProps } from '../../../../constants';
import { ConfirmWarning } from '../../../../utils/confirm';

/**
 * 컨트롤러
 * @window w_tb_e501w_week
 * @category 주간업무보고서
 */
export class WeeklyReport extends React.Component<ExternalPageProps> {
  componentDidMount(): void {
    ConfirmWarning.show('확인', '아직 준비중입니다...');
  }

  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <React.Fragment />
    );
  }
}
